// extracted by mini-css-extract-plugin
export var banner = "_r8-0";
export var settingRow = "_r8-2";
export var titleIcon = "_r8-1";